import Vue from "vue";
import VueRouter from "vue-router";
import privacy from "../views/bluebird/privacy";
import terms from "../views/bluebird/term";
import home from "../views/bluebird/home";
import contact from "../views/hellocaria/contact"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: home
  }, {
    path: "/privacycheck",
    name: "privacy",
    component: privacy
  }, {
    path: "/termscheck",
    name: "terms",
    component: terms
  }, {
    path: "/contact",
    name: "contact",
    component: contact
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
